//core
import React from "react";

// components
import Button from "../Forms/Button/Button";
import LModal from "./LModal/LModal";
import ModalHeader from "./ModalHeader/ModalHeader";

interface IConfirmation {
    isOpen: boolean;
    onClose: () => void;
    url?: string;
}

const Confirmation: React.FC<IConfirmation> = (props) => {
    const {
        url,
        isOpen,
        onClose
    } = props;

    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader onClose={onClose} title="Chubb Life Discount" />
                )}
                calcHeightMode="auto"
                width="narrow"
                isOpen={isOpen}
                onClose={onClose}>
                {() => {
                    return (
                    <React.Fragment>
                        <div>
                        <h4>You have selected that you are eligible for the Chubb 15% Lifetime Reward Discount.</h4>
                        <p>To be eligible for this, you must be a non-smoker and have a BMI between 18.5 to 24.99 at the time of application.</p>
                        <p>If you aren't eligible, the discount would not be applicable to you and the quote you have selected won't be correct.</p>
                        <p>If you'd like to check your BMI, you can use our <a href="/calculators/bmi" target="_blank">calculator</a>.</p>
                        <Button component="a" target="_blank" href={url} className="button-confirmation" >Continue</Button>
                        </div>
                    </React.Fragment>  
                    )
                } }
            </LModal>
        </React.Fragment>
     );
};

export default Confirmation;